// extracted by css-extract-rspack-plugin
export default {"container":"variable-picker__container___t0n_u"};